import api from '../api/axios';

/**
 * URL base per le API delle notifiche
 */
const BASE_URL = `api/notifications/notifications/`;

/**
 * Ottiene le notifiche dell'utente autenticato.
 * Restituisce `{ results, next }` per supportare la paginazione "Mostra altre".
 *
 * @param {string|null} nextUrl - URL `next` ritornato dal backend (per pagine successive)
 * @param {string|null} signalFunctionName - filtro opzionale per tipo
 */
export async function getNotifications(nextUrl = null, signalFunctionName = null) {
  let response;
  if (nextUrl) {
    // Estrai path + query dall'URL assoluto del backend per usare baseURL di axios
    const url = new URL(nextUrl);
    response = await api.get(url.pathname.replace(/^\//, '') + url.search);
  } else {
    const params = {};
    if (signalFunctionName) {
      params.signal_function_name = signalFunctionName;
    }
    response = await api.get(BASE_URL, { params });
  }

  const data = response.data;
  if (Array.isArray(data)) {
    return { results: data, next: null };
  }
  return {
    results: Array.isArray(data?.results) ? data.results : [],
    next: data?.next ?? null,
  };
}

/**
 * Ottiene i dettagli di una singola notifica
 */
export function getNotification(id) {
  return api.get(`${BASE_URL}${id}/`);
}

/**
 * Segna una notifica specifica come letta
 */
export function markAsRead(id) {
  return api.post(`${BASE_URL}${id}/mark_as_read/`);
}

/**
 * Segna tutte le notifiche come lette
 */
export function markAllAsRead() {
  return api.post(`${BASE_URL}mark_all_as_read/`);
}

/**
 * Conta le notifiche non lette tramite l'endpoint dedicato del backend.
 */
export async function getUnreadCount() {
  const response = await api.get(`${BASE_URL}unread_count/`);
  return response.data?.count ?? 0;
}

/**
 * Ottiene solo le notifiche non lette
 */
export function getUnreadNotifications(signalFunctionName = null) {
  const params = { is_read: false };
  if (signalFunctionName) {
    params.signal_function_name = signalFunctionName;
  }
  return api.get(BASE_URL, { params });
} 